<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_15"></a>PART I<br/><em>The View from London</em></h2>
<p class="centerp">For if America should grow into a separate empire it must of course cause . . . a revolution in the political system of the world.</p>
<p class="centerp1">S<span class="small">PEECH OF</span> L<span class="small">ORD</span> N<span class="small">ORTH</span>, November 20, 1778<a id="page_16"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?7d044813